{
  "_from": "seek-bzip@^1.0.5",
  "_id": "seek-bzip@1.0.5",
  "_inBundle": false,
  "_integrity": "sha1-z+kXyz0nS8/6x5J1ivUxc+sfq9w=",
  "_location": "/seek-bzip",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "seek-bzip@^1.0.5",
    "name": "seek-bzip",
    "escapedName": "seek-bzip",
    "rawSpec": "^1.0.5",
    "saveSpec": null,
    "fetchSpec": "^1.0.5"
  },
  "_requiredBy": [
    "/"
  ],
  "_resolved": "https://registry.npmjs.org/seek-bzip/-/seek-bzip-1.0.5.tgz",
  "_shasum": "cfe917cb3d274bcffac792758af53173eb1fabdc",
  "_spec": "seek-bzip@^1.0.5",
  "_where": "/home/kremit/dev/web/js/wxnetlive",
  "bin": {
    "seek-bunzip": "bin/seek-bunzip",
    "seek-table": "bin/seek-bzip-table"
  },
  "bugs": {
    "url": "https://github.com/cscott/seek-bzip/issues"
  },
  "bundleDependencies": false,
  "contributors": [
    {
      "name": "C. Scott Ananian",
      "url": "http://cscott.net"
    },
    {
      "name": "Eli Skeggs"
    },
    {
      "name": "Kevin Kwok"
    },
    {
      "name": "Rob Landley",
      "url": "http://landley.net"
    }
  ],
  "dependencies": {
    "commander": "~2.8.1"
  },
  "deprecated": false,
  "description": "a pure-JavaScript Node.JS module for random-access decoding bzip2 data",
  "devDependencies": {
    "fibers": "~1.0.6",
    "mocha": "~2.2.5"
  },
  "directories": {
    "test": "test"
  },
  "homepage": "https://github.com/cscott/seek-bzip#readme",
  "license": "MIT",
  "main": "./lib/index.js",
  "name": "seek-bzip",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/cscott/seek-bzip.git"
  },
  "scripts": {
    "test": "mocha"
  },
  "version": "1.0.5"
}
